import React, { Component } from "react";

class CryptoBankCRUD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: false,
      error: "",

      // modal/form
      showModal: false,
      modalMode: "create", // create | edit
      form: { id: "", crypto_name: "" },
      submitting: false,
      deletingId: null,

      search: "",
    };
  }

  // Samakan base URL seperti VideoYoutubeList: "https://api.backofficemain.com/..."
  api = {
    list: "https://api.backofficemain.com/get_crypto_bank1.php",
    add: "https://api.backofficemain.com/add_crypto_bank.php",
    update: "https://api.backofficemain.com/update_crypto_bank.php",
    delete: "https://api.backofficemain.com/delete_crypto_bank.php",
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const response = await fetch(this.api.list);
      const data = await response.json();
      this.setState({ items: Array.isArray(data) ? data : [], loading: false });
    } catch (error) {
      console.error("Error loading crypto bank:", error);
      this.setState({ loading: false, error: "Error loading data!" });
    }
  };

  openCreateModal = () => {
    this.setState({
      showModal: true,
      modalMode: "create",
      form: { id: "", crypto_name: "" },
      error: "",
    });
  };

  openEditModal = (item) => {
    this.setState({
      showModal: true,
      modalMode: "edit",
      form: { id: String(item.id), crypto_name: item.crypto_name || "" },
      error: "",
    });
  };

  closeModal = () => {
    if (this.state.submitting) return;
    this.setState({ showModal: false, error: "" });
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ form: { ...prev.form, [name]: value } }));
  };

  onSearchChange = (e) => this.setState({ search: e.target.value });

  validate = () => {
    const name = (this.state.form.crypto_name || "").trim();
    if (!name) return "crypto_name wajib diisi.";
    if (name.length > 100) return "crypto_name maksimal 100 karakter.";
    return "";
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const err = this.validate();
    if (err) {
      this.setState({ error: err });
      return;
    }

    const { modalMode, form } = this.state;

    try {
      this.setState({ submitting: true, error: "" });

      const formData = new FormData();
      formData.append("crypto_name", form.crypto_name.trim());

      let url = this.api.add;
      if (modalMode === "edit") {
        url = this.api.update;
        formData.append("id", form.id);
      }

      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert(result.message || "Success!");
        this.setState({ showModal: false, submitting: false });
        this.loadData();
      } else {
        alert(result.message || "Error!");
        this.setState({ submitting: false, error: result.message || "Error!" });
      }
    } catch (error) {
      console.error("Error saving crypto bank:", error);
      this.setState({ submitting: false, error: "Error saving data!" });
    }
  };

  handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    try {
      this.setState({ deletingId: id, error: "" });

      const formData = new FormData();
      formData.append("id", id);

      const response = await fetch(this.api.delete, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        // seperti VideoYoutubeList: update state tanpa reload juga boleh
        this.setState((prev) => ({
          items: prev.items.filter((x) => String(x.id) !== String(id)),
          deletingId: null,
        }));
      } else {
        alert(result.message || "Error deleting!");
        this.setState({ deletingId: null, error: result.message || "Error deleting!" });
      }
    } catch (error) {
      console.error("Error deleting crypto bank:", error);
      this.setState({ deletingId: null, error: "Error deleting data!" });
    }
  };

  filteredItems = () => {
    const q = (this.state.search || "").trim().toLowerCase();
    if (!q) return this.state.items;
    return this.state.items.filter((x) =>
      String(x.crypto_name || "").toLowerCase().includes(q)
    );
  };

  renderModal() {
    const { showModal, modalMode, form, submitting, error } = this.state;
    if (!showModal) return null;

    return (
      <div
        className="modal d-block"
        tabIndex="-1"
        role="dialog"
        style={{ background: "rgba(0,0,0,.5)" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form onSubmit={this.handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalMode === "create" ? "Tambah Crypto Bank" : "Edit Crypto Bank"}
                </h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModal} />
              </div>

              <div className="modal-body">
                {error ? <div className="alert alert-danger py-2">{error}</div> : null}

                {modalMode === "edit" ? (
                  <div className="mb-3">
                    <label className="form-label">ID</label>
                    <input className="form-control" value={form.id} disabled />
                  </div>
                ) : null}

                <div className="mb-3">
                  <label className="form-label">Crypto Name</label>
                  <input
                    type="text"
                    name="crypto_name"
                    className="form-control"
                    value={form.crypto_name}
                    onChange={this.onChange}
                    placeholder="contoh: Bitcoin"
                    maxLength={100}
                    autoFocus
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.closeModal} disabled={submitting}>
                  Batal
                </button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? "Menyimpan..." : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, deletingId, search } = this.state;
    const rows = this.filteredItems();

    return (
      <div className="container py-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h3 className="m-0">Crypto Bank</h3>
          <button className="btn btn-success" onClick={this.openCreateModal}>
            + Tambah
          </button>
        </div>

        <div className="row g-2 mb-3">
          <div className="col-md-6">
            <input
              className="form-control"
              placeholder="Cari crypto_name..."
              value={search}
              onChange={this.onSearchChange}
            />
          </div>
          <div className="col-md-6 text-md-end">
            <button className="btn btn-outline-primary" onClick={this.loadData} disabled={loading}>
              {loading ? "Memuat..." : "Refresh"}
            </button>
          </div>
        </div>

        {error ? <div className="alert alert-danger">{error}</div> : null}

        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: 90 }}>ID</th>
                <th>Crypto Name</th>
                <th style={{ width: 180 }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="3">Memuat data...</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan="3">Tidak ada data.</td></tr>
              ) : (
                rows.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.crypto_name}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-warning" onClick={() => this.openEditModal(item)}>
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => this.handleDelete(item.id)}
                          disabled={String(deletingId) === String(item.id)}
                        >
                          {String(deletingId) === String(item.id) ? "Menghapus..." : "Hapus"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {this.renderModal()}
      </div>
    );
  }
}

export default CryptoBankCRUD;
